import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Container,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  Label,
  Input,
  Button,
  FormFeedback,
  Alert,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

// Service
import commonService from "../../../services/common.service";

const TaskTypeForm = (props: any) => {
  let taskTypeData = props.taskTypeData;

  const validationSchema = Yup.object().shape({
    task_type_value: Yup.string()
      .required("The task type field is required.")
      .min(2, "The task type must be at least 2 characters.")
      .max(200, "The task type may not be greater than 200 characters."),
  });

  const handleSubmit = (values: {
    id: string;
    task_type_id: string;
    task_type_value: string;
    color_code: string;
  }) => {
    props.onSubmitClick(values);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (taskTypeData && taskTypeData.id) || "",
      task_type_id: (taskTypeData && taskTypeData.task_type_id) || "",
      task_type_value: (taskTypeData && taskTypeData.task_type_value) || "",
      color_code: (taskTypeData && taskTypeData.color_code) || "#000000",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setErrors }) => {
      handleSubmit(values);
    },
  });

  useEffect(() => {
    if (!validation.isSubmitting) return;
    if (Object.keys(validation.errors).length > 0) {
      document
        .getElementById(Object.keys(validation.errors)[0])
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      document
        .getElementById(Object.keys(validation.errors)[0])
        ?.focus({ preventScroll: true });
    }
  }, [validation.isSubmitting, validation.errors]);

  return (
    <React.Fragment>
      <Modal
        size="md"
        isOpen={props.show}
        toggle={props.onCloseClick}
        backdrop="static"
        keyboard={false}
        autoFocus={false}
      >
        <div className="modal-header">
          <h5 className="modal-title">{props.modalTitle}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={props.onCloseClick}
            aria-label="Close"
          ></button>
        </div>

        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
          autoComplete="off"
        >
          <ModalBody>
            {props.errorMsg ? 
              <Alert color="danger">
                {props.errorMsg}

                {props.errorData.data ?
                  Object.keys(props.errorData.data).map(key => (
                    <li color="danger" key={key}>{props.errorData.data[key]}</li>
                  )) : null
                }
              </Alert> : null
            }

            <Input
              id="id"
              name="id"
              type="hidden"
              value={validation.values.id || ""}
              onChange={validation.handleChange}
            />
            <Input
              id="task_type_id"
              name="task_type_id"
              type="hidden"
              value={validation.values.task_type_id || ""}
              onChange={validation.handleChange}
            />

            <Row>
              <Col className="col-12">
                <div className="mb-3">
                  <Label className="form-label">
                    Task type{" "}
                    <span className="text-warning is_required">*</span>
                  </Label>
                  <div className="color_palette_main_div">
                    <Input
                      id="task_type_value"
                      name="task_type_value"
                      className="form-control"
                      placeholder="Task type"
                      type="text"
                      value={validation.values.task_type_value || ""}
                      autoFocus={true}
                      onKeyUp={validation.handleChange}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.task_type_value &&
                        validation.errors.task_type_value
                          ? true
                          : false
                      }
                    />
                    {validation.touched.task_type_value &&
                    validation.errors.task_type_value ? (
                      <FormFeedback type="invalid">
                        {validation.errors.task_type_value}
                      </FormFeedback>
                    ) : null}

                    <div className="color_palette_div">
                      <Input
                        id="color_code"
                        name="color_code"
                        type="color"
                        value={validation.values.color_code || ""}
                        className="color_palette"
                        onChange={validation.handleChange}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              className="btn-block"
              type="submit"
              disabled={props.loading}
            >
              {props.loading ? (
                <span>
                  <i className="fa-solid fa-spinner fa-spin"></i>
                  <span>&nbsp; Please wait...</span>
                </span>
              ) : (
                <span>Submit</span>
              )}
            </Button>
            <Button
              color="danger"
              className="btn-block"
              type="reset"
              onClick={props.onCloseClick}
              disabled={props.loading}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
};

export default TaskTypeForm;
